var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-align-center"},[_c('img',{style:({ width: _vm.width }),attrs:{"src":require('@cdn?273b49494922'),"alt":""}}),_c('div',{staticClass:"fs14 c999"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }